<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import { useGameStore } from '@/stores/gameStore.ts'
import { usePlanetStore } from '@/stores/planetStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const gameStore = useGameStore()
const planetStore = usePlanetStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_planet_intro')
}

const isOnPlanetsSection = computed(() => {
  return route.path.startsWith('/planets')
})

const goToPlanets = () => {
  router.push('/planets')
}


</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/planet.webm"
  >
    <template #text>
      <p class="pb-2">
        Nice to meet you!, i'm your planet governing advisor.
      </p>
      <p class="pb-2">
        Our planets give us the resources needed to grow, research and build our armies.
      </p>
      <p class="pb-2">
        I'll show you how to control your planets, lets navigate to the correct screen first.
      </p>
    </template>

    <template #alerts>
      <Alert type="info" class="hidden md:flex">
        Click on the "Planets" button in the top menu. Then select your home world in the list on the left. The planet detail screen will load on the right.
      </Alert>
      <Alert type="info" class="md:hidden">
        Click on the "Menu" in the right top of your screen, then select "Planets". Finally, select your home world. Next you will see your planet detail screen.
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnPlanetsSection" @click="goToPlanets" class="mr-2">
        Goto Planets
      </ActionButton>
      <ActionButton @click="handleNextStep">
        I'm there
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>